import Usuario from "@/models/Usuario";
import Notificacao from "@/models/Notificacao";
import { defineStore } from "pinia";
import http from "@/http";

export const useSgcqStore = defineStore("SgcqStore", {
  state: () => {
    return {
      usuario: new Usuario("", "", ""),
      notificacao: new Notificacao("", "", ""),
      abas: [],
      reports: [],
    };
  },
  //persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    EFETUAR_LOGIN(login) {
      return new Promise((resolve, reject) => {
        http
          .post("api/auth", login)
          .then((response) => {
            this.usuario = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    EFETUAR_LOGOUT() {
      this.usuario = new Usuario("", "", "");
      this.abas = [];
      this.notificacao = new Notificacao(new Date().getTime(), "", "", "");
    },

    ADICIONA_ABA(aba) {
      this.abas.push(aba);
    },

    REMOVE_ABA(tipo) {
      const index = this.abas.findIndex((value) => value.tipo == tipo);
      this.abas.splice(index, 1);
    },

    ADICIONA_REPORT(report) {
      this.reports.push(report);
    },

    REMOVE_REPORT(tipo) {
      const index = this.reports.findIndex((value) => value.tipo == tipo);
      this.reports.splice(index, 1);
    },

    NOTIFICAR(novaNotificacao) {
      this.notificacao = novaNotificacao;
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getUser() {
      return this.usuario;
    },

    getAbas() {
      return this.abas;
    },

    getReports() {
      return this.reports;
    },

    getNotificacoes() {
      return this.notificacoes;
    },

    authenticated(state) {
      if (state.usuario.token == null) {
        return false;
      } else {
        return true;
      }
    },

    getToken(state) {
      return state.usuario.token;
    },
  },
});
